import Yup from '../../../../utils/yup';
import { rucValidator } from '../../../Validations';

export function validationFunctionCategory(values) {
  const errors = {};
  // Custom Validations
  return errors;
}

export const validationSchemaCategory = Yup.object().shape({
  name: Yup.string().required(),
});
